export enum StaffRole {
    ADMIN = 'admin',
    OWNER = 'owner',
    EMPLOYEE = 'employee',
};

export const StaffRoleLevels: Record<StaffRole, number> = {
    [StaffRole.ADMIN]: 100,
    [StaffRole.OWNER]: 80,
    [StaffRole.EMPLOYEE]: 10,
};

export type LocationRoleSelection = {
    locationId: number;
    role: StaffRole;
};

export interface Staff {
    autocheckinwithanpr: boolean;
    email: string;
    id: number;
    licenseplate?: string;
    name: string;
    phonenumber: string;
    receivesadminmessages: boolean;
    receivescustomeralerts: boolean;
    receivesownermessages: boolean;
    role: StaffRole;
    useswhatsappforalerts: boolean;
    // these are only for internal use
    autocheckoutafteranprminutes: number;
    canaccessadministration: boolean;
    canaccessreports: boolean;
    needsenroll: boolean;
};

export interface LocationStaff {
    locationName: string;
    staff: Staff[];
}

export interface CreateStaffPayload {
    // TODO should we add role here?
    name: string;
    phoneNumber: string;
    email?: string;
    password?: string;
    licensePlate?: string;
    receivesCustomerAlerts?: boolean;
    receivesOwnerMessages?: boolean;
    receivesAdminMessages?: boolean;
    autoCheckinWithANPR?: boolean;
    usesWhatsappForAlerts?: boolean;
    role: StaffRole;
    locationId: number;
}

export interface UpdateStaffPayload {
    staffId: number;
    name: string;
    phoneNumber: string;
    licensePlate?: string;
    email?: string;
    password?: string;
    receivesCustomerAlerts?: boolean;
    receivesOwnerMessages?: boolean;
    receivesAdminMessages?: boolean;
    autoCheckinWithANPR?: boolean;
    usesWhatsappForAlerts?: boolean;
    role?: StaffRole;
    needsEnroll: boolean;
    // todo remove locationId after backend update (when role will be updated directly on update call)
    locationId: number;
}

export interface ChangePasswordPayload {
    staffId: number;
    newPassword: string;
}

export interface CreateStaffWithRolesPayload extends CreateStaffPayload {
    locationRoles?: LocationRoleSelection[];
}
